"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupIntentCancellationReason = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var SetupIntentCancellationReason;
(function (SetupIntentCancellationReason) {
    SetupIntentCancellationReason["ABANDONED"] = "abandoned";
    SetupIntentCancellationReason["REQUESTED_BY_CUSTOMER"] = "requested_by_customer";
    SetupIntentCancellationReason["DUPLICATE"] = "duplicate";
    SetupIntentCancellationReason["FRAUDULENT"] = "fraudulent";
    SetupIntentCancellationReason["FAILED_OTHER"] = "failed_other";
})(SetupIntentCancellationReason || (exports.SetupIntentCancellationReason = SetupIntentCancellationReason = {}));
